import $ from 'jquery';
import '../vendor/storageapi.js';
import Cookie from 'js-cookie';
import Loop54Connector from '../search/loop54-connector';
const loop54Connector = new Loop54Connector();

const dataLayer = window.dataLayer || [];

let storage = $.sessionStorage;

const deviceDetector = (function ()
{
	var ua = navigator.userAgent.toLowerCase();
	var detect = (function(s)
	{
		if(s===undefined)s=ua;
		else ua = s.toLowerCase();
		if(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(ua))
			return 't';
		else
		if(/(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(ua))
			return 'm';
		else return 'd';
	});
	return{
		device: detect(),
		detect: detect,
		isMobile: ((detect()!=='d')?true:false),
		userAgent: ua
	};
}());

let productImpressionsSent = false;

const GTMEvents = {
	eventTimeout: 2000,

	isEnabled: function() {
		return !!window.google_tag_manager;
	},

	setUser: function(){
		var userId = Cookie.get('loggedIn');
		if( userId ){
			dataLayer.push({
				'event': 'setEmail',
				'email': userId
			})
		}

		dataLayer.push({
			'event': 'setSiteType',
			'type': deviceDetector.device
		})

		this.setCustobarId();
	},

	setRegistration: function() {
		dataLayer.push({
			event: 'clubRegistration'
		});

		Cookie.remove('register_user');
	},

	setCustobarId: function() {
		const custobarId = Cookie.get('kplussa_number') || false;
		if (custobarId) {
			dataLayer.push({
				'isCustobarId': custobarId
			});
		}
	},

	/**
	 * Click product analytics event.

	 * @param {Object} productData - Product data.
	 * @param {boolean} [newTab] - If true, will not do redirect to product url.
	 * @param {function} [callback] - Callback function for eventCallback (this can fire multiple times if there are multiple GTM containers).
	 */
	clickProduct: function(productData, newTab, callback) {

		try {
			storage.set('GoogleTagManagerPreviousPage', window.location.pathname.replace('/fi/','').slice(0, -1));
		} catch (e) {
			console.log(e);
		}

		const list = window.location.pathname.replace('/fi/','').slice(0, -1).toLowerCase();
		var products = [{
			'id': String(productData.id),
			'name': this.normalizeName(productData.brand) + ' ' + this.normalizeName(productData.name),
			'brand': this.normalizeName(productData.brand),
			'list': list,
			'category': this.normalizeName(productData.category),
			'dimension9': this.normalizeName(productData.targetgroup),
			'dimension11': this.normalizeName(productData.sports),
			'dimension16': productData.dimension16,
			'price': productData.price,
			'position': productData.position
		}];
		if (productData.breadcrumb) {
			products[0].dimension13 = this.normalizeName(productData.breadcrumb);
		}

		// It might be better to wait until last callback...
		const redirect = {
			do: () => {
				window.location.href = productData.link;
			}
		};

		dataLayer.push({
			'UserLoggedIn': !!Cookie.get('loggedIn'),
			'event': 'productClick',
			'ecommerce': {
				'click': {
					'actionField': {
						'list': list
					},
					'products': products
				}
			},
			'eventCallback': callback ? callback : () => {
				if (!newTab) {
					if (typeof redirect.do === 'function') {
						redirect.do();
						// Run only once if there are multiple GTM containers.
						redirect.do = false;
					}
				}
			},
			'eventTimeout': this.eventTimeout
		});
	},
	clickBanner: function (url){
		var campaign = '';

		if(url.indexOf('kampanjat') > -1){
			campaign = url.split('/')[3];
		}
		else if(url.indexOf('kampanja') > -1){
			campaign = url.split('/')[5];
		}
		else{
			campaign = url;
		}

		const redirect = {
			do: () => {
				window.location.href = url;
			}
		};

		dataLayer.push({
			'UserLoggedIn': !!Cookie.get('loggedIn'),
			'event': 'promotionClick',
			'ecommerce': {
				'promoClick': { // "add" actionFieldObject measures
					'promotions': [{ // adding product to cart
						'name': campaign,
						'position': 'Etusivun karuselli'
					}]
				}
			},
			'eventCallback': () => {
				if (typeof redirect.do === 'function') {
					redirect.do();
					// Run only once if there are multiple GTM containers.
					redirect.do = false;
				}
			},
			'eventTimeout': this.eventTimeout
		});

	},
	clickMegaMenuItem: function (url){
		var mainCat = $('ul.product-links li.selected > a').html();

		const redirect = {
			do: () => {
				window.location.href = url;
			}
		};

		dataLayer.push({
			'UserLoggedIn': !!Cookie.get('loggedIn'),
			'event': 'GAEvent',
			'eventCategory': 'meganavi',
			'eventAction': 'clickLink',
			'eventLabel': 'mainCategory: ' + mainCat + ', link: ' + url,
			'eventCallback': () => {
				if (typeof redirect.do === 'function') {
					redirect.do();
					// Run only once if there are multiple GTM containers.
					redirect.do = false;
				}
			},
			'eventTimeout': this.eventTimeout
		});

	},
	addToCart: function (id, ean, quantity, color, colorValue, name, brand, category, sports, targetgroup, breadcrumb, price, saleProduct, productType, carousel, searchWords) {
		var list = '';
		if( storage.isSet('GoogleTagManagerPreviousPage') ){
			list = storage.get('GoogleTagManagerPreviousPage').toLowerCase();
		}

		//Add cookie for product-carousel dimension
		if (carousel === 'product-carousel') {
			document.cookie = `carousel=${id};path=/`;
		}

		//Add product searchwords with sapId to site search dimension (dimension34)
		if (searchWords) {
			const prevCookie = Cookie.get('searchWords');
			prevCookie && Cookie.set('searchWords', prevCookie.concat(`|${id}-${searchWords}`));
		}

		let dim34 = 'normal';
		if (carousel === 'product-carousel') {
			dim34 = 'product-carousel';
		} else if (productType === 'Upsale') {
			dim34 = 'cross-sell';
		} else if (searchWords) {
			dim34 = `Site Search:${searchWords}`;
		}

		const dim16 = `${id}_${colorValue}`;

		if (id && colorValue) {
			const entity = { type: 'Product', id: dim16 };
			try {
				loop54Connector.createEvent('addtocart', entity);
			} catch (error) {
				console.log(error);
			}
		}

		var products = [{ // adding product to cart
			'id': String(id),
			'ean': ean,
			'quantity': parseInt(quantity),
			'variant': this.normalizeName(color),
			'name': this.normalizeName(brand) + ' ' + this.normalizeName(name),
			'brand': this.normalizeName(brand),
			'category': this.normalizeName(category),
			'dimension9': this.normalizeName(targetgroup),
			'dimension11': this.normalizeName(sports),
			'dimension13': this.normalizeName(breadcrumb),
			'dimension16': dim16,
			'price': price,
			'dimension28': this.normalizeName(saleProduct),
			'productType': productType,
			'dimension34': dim34
		}]

		dataLayer.push({
			'UserLoggedIn': !!Cookie.get('loggedIn'),
			'event': 'addToCart',
			'ecommerce': {
				'currencyCode': 'EUR',
				'add': { // "add" actionFieldObject measures
					'actionField': {
						'list': list
					},
					'products': products
				}
			}
		});

	},
	removeFromCart: function (id, ean, quantity, color, name, brand, category, sports, targetgroup, breadcrumb, price, saleProduct) {

		var products = [{ // removing product to cart
			'id': String(id),
			'ean': ean,
			'quantity': parseInt(quantity),
			'variant': typeof color !== 'undefined' ? this.normalizeName(color) : '',
			'name': typeof name !== 'undefined' ? this.normalizeName(brand) + ' ' + this.normalizeName(name) : '',
			'brand': typeof brand !== 'undefined' ? this.normalizeName(brand) : '',
			'category': typeof category !== 'undefined' ? this.normalizeName(category) : '',
			'dimension9': typeof targetgroup !== 'undefined' ? this.normalizeName(targetgroup) : '',
			'dimension11': typeof sports !== 'undefined' ? this.normalizeName(sports) : '',
			'dimension13': typeof breadcrumb !== 'undefined' ? this.normalizeName(breadcrumb) : '',
			'price': price,
			'dimension28': saleProduct === '1' || saleProduct === 1 ? 'lastchance' : 'normal'
		}]
		dataLayer.push({
			'UserLoggedIn': !!Cookie.get('loggedIn'),
			'event': 'removeFromCart',
			'ecommerce': {
				'remove': { // "remove" actionFieldObject measures
					'products': products
				}
			}
		});

	},
	extraSaleAddToCart: function (productName) {
		dataLayer.push({
			'eventCategory': 'Upsale',
			'eventAction': 'AddToCart',
			'eventLabel': productName
		}
		);
	},
	categoryImpressions: function (data){
		//var category = window.location.pathname.replace('/fi','');
		var list = window.location.pathname.replace('/fi/','').slice(0, -1).toLowerCase();
		if( typeof(data?.ecommerce?.impressions) !== 'undefined' ){
			data.ecommerce.impressions.forEach(function(product){
				product.list = list;
			})
		}
		dataLayer.push(data);
	},
	productImpressions: function (products) {
		if (!productImpressionsSent) {
			window.dataLayer.push({
				event: 'productImpression', // Because we trigger this multiple times
				ecommerce: {
					impressions: products
				}
			});
			productImpressionsSent = true;
		}
	},
	productDetailView: function (data){
		var poll = null;
		var list = '';

		poll = setInterval( function(){
			// wait until storage api is loaded
			if( storage ){

				clearInterval(poll);

				if( storage.isSet('GoogleTagManagerPreviousPage') ){
					list = storage.get('GoogleTagManagerPreviousPage').toLowerCase()
				}

				if( typeof(data.ecommerce.detail.products) !== 'undefined' ){
					data.ecommerce.actionField = {
						list: list
					}
				}
				data.UserLoggedIn = !!Cookie.get('loggedIn');
				//console.log('productDetailView : ' + JSON.stringify(data.ecommerce.detail.products))
				dataLayer.push(data);
			}
		}, 1000);
	},
	normalizeName: function(name){
		return ( name || '' ).trim().toLowerCase();
	},
	clickFilter: function (category, filter) {
		/*console.log({
            'event' : 'GAEvent',
            'eventCategory' : 'Filters',
            'eventAction' : 'Select filter',
            'eventLabel' : category + ': ' + filter,
            'eventNonInteraction' : 'false',
            'eventValue' : ''
        });*/

		dataLayer.push(
			{
				'event': 'GAEvent',
				'eventCategory': 'Filters',
				'eventAction': 'Select filter',
				'eventLabel': category + ': ' + filter,
				'eventNonInteraction': 'false',
				'eventValue': ''
			}
		);
	},
}

export const GoogleTagManager = GTMEvents;

export default function (API) {

	function datalayerEvent(category, action, label, event = 'GAEvent') {
		const pushEvent = {
			'event': event,
			'eventCategory': category,
			'eventAction': action,
			'eventLabel': label
		}
		window.dataLayer.push(pushEvent);
	}

	$('.link-list-container').on('click', 'a', function(e) {
		const title = $(this).parentsUntil('.link-list-collection').find('.link-list-title').text();
		const text = $(this).text();
		const label = title + ',' + text;
		datalayerEvent('SEO link list', 'Link click', label, 'GAEvent');
	});

	GoogleTagManager.setUser();

	if (Cookie.get('register_user') === '1') {
		GoogleTagManager.setRegistration();
	}

	// Push Loop54 purchase events when on thank you page.
	if (global.__purchaseEvents !== 'undefined') {
		if (Array.isArray(global.__purchaseEvents)) {
			try {
				loop54Connector.createEvent('purchase', global.__purchaseEvents);
			} catch (error) {
				console.log(error);
			}
		}
	}

}
